import { Button } from '../../../shared/Button';
import { ButtonElement } from '../../../shared/Button/Button.styled';
import { PalletteProps } from '../../../types/theme/pallette';
import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 600px;
  width: 100%;
  margin: 0 0 26px 0;
  padding: 31px 44px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 0px 50px rgba(200, 200, 200, 0.2);
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }: PalletteProps) => theme.gray2};
  margin-bottom: 31px;
`;

export const ButtonsWrapper = styled.div`
  max-width: 600px;
  margin: 0 0 26px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  ${ButtonElement} {
    width: 113px;
    height: 41px;
    text-transform: capitalize;
    font-family: 'Inter';
    font-weight: 700;
    font-size: 1rem;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const CancelButton = styled(Button)`
  background-color: ${({ theme }: PalletteProps) => theme.gray4};
  color: ${({ theme }: PalletteProps) => theme.gray2};
  margin-right: 10px;
  &:hover {
    background: ${({ theme }: PalletteProps) => theme.gray4};
  }
`;

export const SpinnerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const Spinner = styled.div`
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid #fff;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const ExpirationDateLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: ${({ theme }: PalletteProps) => theme.gray2};
`;

export const ExpirationDateWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const ExpirationSelect = styled.select`
  background-color: ${({ theme }: PalletteProps)=> theme.gray8};
  padding: 13px 8px;
  border-color: transparent;
  font-size: 1rem;
  font-weight: 300;
  border-radius: 10px;
  height: 48px;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 1em;
  
  &:focus {
    outline-color: ${({ theme }: PalletteProps) => theme.primaryColor};
  }

  & option:disabled {
    color: ${({ theme }: PalletteProps) => theme.gray4};
  }

  &:invalid {
    color: ${({ theme }: PalletteProps) => theme.gray4};
  }
`;

export const MonthSelect = styled(ExpirationSelect)`
  width: 40%;
`;

export const YearSelect = styled(ExpirationSelect)`
  width: 60%;
`;

export const ErrorMessage = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;